// src/App.js
import React, { useState } from "react";
import { QueryClient, QueryClientProvider } from "react-query";
import { ThemeProvider } from "@mui/material/styles";
import CssBaseline from "@mui/material/CssBaseline";
import theme from "./theme";
import { UserContext } from "./utils";
import { setHeaderAndInterceptors } from "./api/client";
import {Navigator} from "./navigation"; // your existing navigation (optional)
import ParentalGuide from "./pages/ParentalGuide";
import FreeChapter from "./pages/FreeChapter";
import OrderForm from "./components/OrderForm";
import ThankYouPage from "./pages/ThankYou";
import PositivePsychology from "./pages/PositivePsychology";
import Header from "./components/Header";
import "./App.css";

// If you already have a theme file, import it instead:
// import theme from "./theme";

const queryClient = new QueryClient();


export default function App() {
  // keep exactly like your original logic for user data and headers
  const localData = localStorage.getItem("userData");
  const [userData, setUserData] = useState(localData ? JSON.parse(localData) : null);
  if (localData) {
    // ensure the interceptor is set only once (you may want to guard this in real app)
    setHeaderAndInterceptors(JSON.parse(localData).token, setUserData);
  }

  return (
    <UserContext.Provider value={{ userData, setUserData }}>
      <QueryClientProvider client={queryClient}>
        <ThemeProvider theme={theme}>
          <CssBaseline />
          <Navigator />
        </ThemeProvider>
      </QueryClientProvider>
    </UserContext.Provider>
  );
}
